var _require = require("./storeHoursCalc.js"),
  calcOrderTimes = _require.calcOrderTimes,
  calcStoreOpeningTimes = _require.calcStoreOpeningTimes;
var _require2 = require('./module/cart'),
  calculateCart = _require2.calculateCart;
var convertPurchaseListToBackendFormat = require("./convertPurchaseListToBackendFormat.js");
var reportFeeBuster = require('./reportFeeBuster.js');
var _require3 = require('./utils.js'),
  isProduct = _require3.isProduct;
var _require4 = require("./upcValidation.js"),
  isValidUpc = _require4.isValidUpc,
  validateCheckDigit = _require4.validateCheckDigit;
var packBasket = require('./packBasket.js');
var unpackBasket = require('./unpackBasket.js');
var getStoreOpenDates = function getStoreOpenDates(dates, waitTime, currentTime) {
  return calcStoreOpeningTimes(dates, waitTime, currentTime);
};
var getHoursLabels = function getHoursLabels(dayDetails, waitTime, currentTime, interval) {
  return calcOrderTimes(dayDetails, waitTime, currentTime, interval);
};
var getUnitCashPrice = function getUnitCashPrice(ccPrice, skuqty, fraction) {
  return +(+(ccPrice * skuqty) / (1 + fraction).toFixed(4)).toFixed();
};
module.exports = {
  calculateCart: calculateCart,
  convertPurchaseListToBackendFormat: convertPurchaseListToBackendFormat,
  getHoursLabels: getHoursLabels,
  getStoreOpenDates: getStoreOpenDates,
  getUnitCashPrice: getUnitCashPrice,
  isProduct: isProduct,
  isValidUpc: isValidUpc,
  packBasket: packBasket,
  reportFeeBuster: reportFeeBuster,
  unpackBasket: unpackBasket,
  validateCheckDigit: validateCheckDigit
};